import globalStyles from '../../styles/exported.module.scss';
import { svgIconsTestIds } from '../tests/testIds';

export const AccordionPlusIcon = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    className={className}
    data-testid={svgIconsTestIds.accordionPlusIcon}
    {...rest}
  >
    <path
      d="M12 5.5V19.5"
      stroke={globalStyles.bdPureBlack}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12.5H19"
      stroke={globalStyles.bdPureBlack}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
